import React from 'react';
import { HouseIcon, InspectionPlannerIcon, NotificationIcon, ProfileIcon, ShortlistIcon, DreamhomeOutlineIcon } from '@domain-group/fe-co-icon';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { RowButton } from '@domain-group/fe-co-allhomes-design-system';
import Menu from '../menu';
import { SeparatorMenuItem } from '../menu/menu';
import * as styles from './membership-menu.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var memberItems = [{
  id: 'watchlist',
  label: 'Watchlist',
  href: '/watchlist',
  icon: ___EmotionJSX(ShortlistIcon, {
    css: styles.icon
  })
}, {
  id: 'property-alerts',
  label: 'Property alerts',
  href: '/property-alerts',
  icon: ___EmotionJSX(NotificationIcon, {
    css: styles.icon
  })
}, {
  id: 'my-listings',
  label: 'My listings',
  href: '/ah/myallhomes/secure/my-listings/view',
  icon: ___EmotionJSX(HouseIcon, {
    css: styles.icon
  })
}, {
  id: 'inspection-planner',
  label: 'Inspection planner',
  href: '/inspection-planner',
  icon: ___EmotionJSX(InspectionPlannerIcon, {
    css: styles.icon
  })
}, {
  id: 'my-properties',
  label: 'My properties',
  href: '/my-properties',
  icon: ___EmotionJSX(DreamhomeOutlineIcon, {
    css: styles.icon
  }),
  isNew: true
}];
var MembershipMenu = _ref => {
  var user = _ref.user,
    _ref$onSignoutClick = _ref.onSignoutClick,
    onSignoutClick = _ref$onSignoutClick === void 0 ? () => {} : _ref$onSignoutClick;
  var _useAllhomesApi = useAllhomesApi(),
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  return ___EmotionJSX(Menu, {
    orientation: "column",
    items: [{
      id: 'profile-summary',
      component: () => ___EmotionJSX(RowButton, {
        css: styles.profile,
        title: "My account",
        label: user.email,
        selected: true,
        leftIcon: ___EmotionJSX(ProfileIcon, {
          css: styles.icon
        })
      })
    }, ...memberItems.filter(memberItem => {
      var memberMenuItem = memberItem;
      return !toggledFeatures || !memberMenuItem || !memberMenuItem.toggledFeature || toggledFeatures[memberMenuItem.toggledFeature];
    }), SeparatorMenuItem, {
      id: 'account-details',
      label: 'Account details',
      href: '/my'
    }, {
      id: 'sign-out',
      label: 'Log out',
      onClick: onSignoutClick
    }]
  });
};
export default MembershipMenu;